import CreateTicket from './CreateTicket';
import EditTicket from './EditTicket';
import List from './List';
import * as React from "react";
import { Route, Routes } from "react-router-dom";
import ShopList from './ShopList';
import CreateShop from './CreateShop';
import EditShop from './EditShop';
import ViewShop from './ViewShop';
import SideBar from '../../components/Dashboard/SideBar';
import View from './View';
import { ConfirmationNumberOutlined, StorefrontOutlined } from '@mui/icons-material';
import CommonContainer from '../../components/common/container/CommonContainer';
import Setting from '../Setting';
import { useTranslation } from 'react-i18next';
import ContactPageOutlinedIcon from '@mui/icons-material/ContactPageOutlined';
import ViewContacts from './contact/ViewContacts';
import ViewContact from './contact/ViewContact';
import EditContact from './contact/EditContact';

const AdminTickets: React.FC<{}> = () => {
  const { t } = useTranslation('translation');
  const sideBarList: any = [
    { list: "Tickets", sublist: [{ name: "TicketList", navUrl: "/admin/dashboard" }], icon: <ConfirmationNumberOutlined sx={{ mr: 1 }} /> },
    { list: "Shops", sublist: [{ name: "shopList", navUrl: "/admin/ShopList" }], icon: <StorefrontOutlined sx={{ mr: 1 }} /> },
    { list: "Contacts", navUrl: "/admin/contacts", icon: <ContactPageOutlinedIcon sx={{ mr: 1 }} /> },
  ];

  return (
    <SideBar sideBarList={sideBarList}>
      <Routes>
        <Route path={"/editTicket/:id"} element={<EditTicket />} />
        <Route path={"/viewTicket/:id"} element={<View />} />
        <Route path={"/createTicket"} element={<CreateTicket />} />
        <Route path={"/dashboard"} element={<List />} />
        <Route path={"/editShop/:id"} element={<EditShop />} />
        <Route path={"/viewShop/:id"} element={<ViewShop />} />
        <Route path={"/createShop"} element={<CreateShop />} />
        <Route path={"/shopList"} element={<ShopList />} />
        <Route path={"/setting/:id?"} element={
          <CommonContainer title={t("settings")} description={t("settingsDescription")} backButtonurl="/admin/ShopList">
            <Setting />
          </CommonContainer>}
        />
        <Route path={"/contacts/view/:id"} element={<ViewContact />} />
        <Route path={"/contacts/edit/:id"} element={<EditContact />} />
        <Route path={"/contacts"} element={<ViewContacts />} />
      </Routes>
    </SideBar>
  );
};

export default AdminTickets;